import { Trans } from "@coworker/locales";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import FixaHelperText from "@coworker/apprestructured/src/shared/wrappers/FixaHelperText/FixaHelperText";
import { StyledFixaModalFooter } from "./StyledModalComponents";

interface TeamModalFooterProps {
  hasProductQualityTeamError: boolean;
  submitTranslationText: string;
  handleSubmit: () => void;
  disableSubmit: boolean;
  handleDelete?: () => void;
  disableDelete?: boolean;
}

const TeamModalFooter = ({
  hasProductQualityTeamError,
  submitTranslationText,
  handleSubmit,
  handleDelete,
  disableSubmit,
  disableDelete,
}: TeamModalFooterProps) => (
  <StyledFixaModalFooter>
    {hasProductQualityTeamError && (
      <FixaHelperText shouldValidate={true}>
        <Trans>onlyOneProductQualityTeamAllowedString</Trans>
      </FixaHelperText>
    )}
    {handleDelete && (
      <FixaButton disabled={disableDelete} type="danger" onClick={handleDelete}>
        <Trans>deleteTeamString</Trans>
      </FixaButton>
    )}
    <FixaButton disabled={disableSubmit} type="primary" onClick={handleSubmit}>
      {submitTranslationText}
    </FixaButton>
  </StyledFixaModalFooter>
);

export default TeamModalFooter;
